import type { MetaArgs } from 'react-router';

import type { RootLoaderData } from '@jane/bloom/types/schemas/bloom/rootLoader';
import { BloomError } from '@jane/bloom/utils/errors/bloomError';

/**
 * Shorthand to retrieve loader data from the root route, which should be a match for every route.
 * @see @jane/bloom/root
 */
export const getRootLoaderData = ({ matches }: MetaArgs): RootLoaderData => {
  if (matches.length === 0)
    throw new BloomError({ message: 'No root loader data found' });

  const [{ loaderData }] = matches;
  return loaderData as RootLoaderData;
};
